import { combineReducers } from "redux";
import { homereducer } from './Reducers'


const rootReducers=combineReducers({data:homereducer})

export default rootReducers;